import { createSelector as reselectCreateSelector } from 'reselect'

// Proxy around reselect incase we need to add to reselect at a later date or move away from it we
// only need to change one place TODO: Needs to be fixed to properly wrap reselect while maintaining types
export const createSelector = reselectCreateSelector
